module.exports = __webpack_public_path__ + "img/logo-mobile.2f9bfa7f.svg";